import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ExternalNotificationEffects } from './external-notification.effects';
import { externalNotificationReducer } from './external-notification.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('externalNotification', externalNotificationReducer),
    EffectsModule.forFeature([ExternalNotificationEffects]),
  ],
})
export class ExternalNotificationStoreModule {}
